<template>
  <div class="market-welfareCouponList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <PullVcWelfareCoupon></PullVcWelfareCoupon>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #id="{ row }">{{ row.id || '---' }}</template>
      <template #thirdId="{ row }">{{ row.thirdId || '---' }}</template>
      <template #productName="{ row }">{{ row.productName || '---' }}</template>
      <template #channelName="{ row }">{{ row.channelName || '---' }}</template>
      <template #type="{ row }">{{ row.type || '---' }}</template>
      <template #typeName="{ row }">{{ row.typeName || '---' }}</template>
      <template #officialPrice="{ row }">{{ row.officialPrice || '---' }}</template>
      <template #price="{ row }">{{ row.price || '---' }}</template>
      <template #officialPrice="{ row }">{{ row.officialPrice || '---' }}</template>
      <template #stock="{ row }">{{ row.stock || '---' }}</template>
      <template #operation="{ scope }">
        <auth-button auth="finance:ratio:create">
          <el-button type="text"  @click="onEdit(scope.row)">编辑</el-button >
        </auth-button>
      </template>
    </Table>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.remark"></div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getWelfareCouponList ,api_getMarketWelfareChannelList} from '@/api/market'
import { api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import PullVcWelfareCoupon from "./components/pullVcWelfareCoupon";
export default {
  name: "marketWelfareCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
    PullVcWelfareCoupon
  },
  data() {

    return {
      renderData: [
        {
          label: "商品名称",
          placeholder: "请输入商品名称",
          type: "input",
          key: "productName",
        },
        {
          label: "品牌名称",
          placeholder: "请输入品牌名称",
          type: "input",
          key: "typeName",
        },
        {
          label: "商品编号",
          placeholder: "请输入商品编号",
          type: "input",
          key: "thirdId",
        },
        {
          label: "商品类型",
          placeholder: "请选择商品类型",
          type: "select",
          multiple: false,
          key: "type",
          option: [
            {
              value: "WelfareCoupon",
              label: "福利券",
            },
            {
              value: "Recharge",
              label: "直充商品",
            },
          ],
        },
        {
          label: "供应商",
          placeholder: "请选择供应商",
          type: "select",
          multiple: false,
          key: "channel",
          option: [],
        },
      ],

      form: {},
      tableThData: [
        { prop: "id", label: "ID", minWidth: "120", },
        { prop: "thirdId", label: "商品编号", minWidth: "120", },
        { prop: "productName", label: "商品名称", minWidth: "180", },
        { prop: "channelName", label: "供应商", minWidth: "120", },
        { prop: "typeName", label: "品牌名称", minWidth: "180", },
        { prop: "type", label: "商品类型", minWidth: "120", },
        { prop: "price", label: "成本价", minWidth: "120", },
        { prop: "officialPrice", label: "官方价", minWidth: "120", },
        { prop: "stock", label: "库存", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "120", },
      ],
      downloadLoading: false,
      syncVoucherCenteLoading:false,
      couponTypeDataObj: {}, // 优惠券类型obj数据
      useRangeTypeDataObj: {
        'Generic': '通用',
        'Mall': '指定商场可用',
        'Store': '指定店铺可用',
      }, // 使用范围obj数据
      issueTypeMap: {
        'Auto': '自动发放',
        'Stock': '库存发放',
      },
      isShowRemarkDialog: false,
      currentRow: {},
    };
  },
  created () {
    this.getCouponTypeData() // 获取优惠券类型数据
    this.getMarketWelfareChannelList() // 获取渠道供应商列表
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.couponTypes && (params.couponTypes = [params.couponTypes]) // 券类型包装成list
      params.statuses && (params.statuses = [params.statuses]) // 券状态包装成list
      const data = await api_getWelfareCouponList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.showImport = true
    },
    async getMarketWelfareChannelList(){
      const res = await api_getMarketWelfareChannelList()
      res.map((item)=>{
        item.label = item.name
        item.value = item.refId
        return  item
      })
      console.log(this.renderData)
      this.renderData[4].option = res || []
    },
    // 获取优惠券类型数据
    async getCouponTypeData() {
      const {couponType=[]} = await api_getConfig(['couponType'])
      let couponTypeObj = {}
      couponType.map(item => {
        couponTypeObj[item.name] = item.desc
      })
      this.couponTypeDataObj = couponTypeObj
    },

    // 查看使用须知
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },
    // 点击编辑
    async onEdit(row) {
      this.$router.push({
        path: `/market/welfareCouponList/create?id=${row.id}`
      });
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-welfareCouponList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    .down-btn {
      padding: 0 10px;
    }
  }

  .copy {
    color: #05C8AF;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
